import {GeofenceExitShiftTimelineEvent} from '@ots-frontend/ots-data';
import {ActionIcon, Text} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCircle} from "@tabler/icons-react";
import {DefaultText} from '../../text/DefaultText/DefaultText';

type Props = {
  event: GeofenceExitShiftTimelineEvent;
  onClick?: (event: GeofenceExitShiftTimelineEvent) => void
};


export const GeofenceExitTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.shift.timeline.geofenceexit.title", "Exited Geofence")}</>
}

export const GeofenceExitTimelineItemBullet = (props: Props) => {
  const {event, onClick} = props;

  if (onClick) {
    return (
      <ActionIcon variant="transparent" onClick={() => onClick(event)}>
        <IconCircle size={12}/>
      </ActionIcon>
    )
  } else {
    return (
      <IconCircle size={12}/>
    )
  }
}

export const GeofenceExitTimelineItem = (props: Props) => {
  const {event} = props;

  return (
    <>
      <Text size="xs" mt={4}>
        <Text color="dimmed" size="sm">
          <DefaultText value={event.siteName}/>
        </Text>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

GeofenceExitTimelineItem.Title = GeofenceExitTimelineItemTitle
GeofenceExitTimelineItem.Bullet = GeofenceExitTimelineItemBullet;
